import { JsonDecoder } from 'ts.data.json';
import { OrderMarkNeedsClarificationResponse } from './model';

export const orderMarkNeedsClarificationResponseDecoder =
    JsonDecoder.object<OrderMarkNeedsClarificationResponse>(
        {
            id: JsonDecoder.string,
            status: JsonDecoder.string
        },
        'OrderMarkNeedsActionResponse'
    );
